/**
 * Vilken svensk huvudkanal som visar VM 2026 (SVT eller TV4).
 * Gruppspel: fotbollsvm2026.se "VM 2026 TV-tider" (par HOME-AWAY).
 * Slutspel: SVT Sport "Guide: Fotbolls-VM 2026 – Matcher och tv-tider" (match_no 73–104).
 * Nyckel slutspel: match_no (FIFA M073–M104) — kanalen är per matchplats, inte lagpar.
 */

const GROUP_PAIR = {
  "MX-ZA": "tv4",
  "KR-CZ": "tv4",
  "CA-BA": "svt",
  "US-PY": "tv4",
  "QA-CH": "tv4",
  "BR-MA": "svt",
  "HT-SCT": "svt",
  "AU-TR": "tv4",
  "DE-CW": "tv4",
  "NL-JP": "tv4",
  "SE-TN": "svt",
  "ES-CV": "svt",
  "BE-EG": "svt",
  "CI-EC": "tv4",
  "FR-SN": "svt",
  "SA-UY": "tv4",
  "IR-NZ": "tv4",
  "IQ-NO": "tv4",
  "AR-DZ": "tv4",
  "AT-JO": "tv4",
  "PT-CD": "tv4",
  "EN-HR": "tv4",
  "GH-PA": "tv4",
  "UZ-CO": "tv4",
  "CZ-ZA": "tv4",
  "CH-BA": "tv4",
  "US-AU": "svt",
  "CA-QA": "tv4",
  "MX-KR": "tv4",
  "SCT-MA": "svt",
  "BR-HT": "tv4",
  "TR-PY": "tv4",
  "NL-SE": "tv4",
  "DE-CI": "tv4",
  "TN-JP": "svt",
  "EC-CW": "tv4",
  "ES-SA": "tv4",
  "BE-IR": "tv4",
  "AR-AT": "svt",
  "UY-CV": "tv4",
  "NZ-EG": "tv4",
  "FR-IQ": "tv4",
  "NO-SN": "svt",
  "PT-UZ": "svt",
  "EN-GH": "svt",
  "JO-DZ": "tv4",
  "PA-HR": "tv4",
  "CO-CD": "tv4",
  "CH-CA": "tv4",
  "BA-QA": "tv4",
  "ZA-KR": "svt",
  "CZ-MX": "svt",
  "CW-CI": "svt",
  "EC-DE": "svt",
  "MA-HT": "tv4",
  "SCT-BR": "tv4",
  "TN-NL": "svt",
  "SE-JP": "svt",
  "TR-US": "tv4",
  "PY-AU": "tv4",
  "NO-FR": "tv4",
  "SN-IQ": "tv4",
  "PA-EN": "svt",
  "HR-GH": "svt",
  "CV-SA": "tv4",
  "UY-ES": "tv4",
  "NZ-BE": "tv4",
  "EG-IR": "tv4",
  "CD-UZ": "tv4",
  "CO-PT": "tv4",
  "DZ-AT": "tv4",
  "JO-AR": "tv4",
};

/** @type {Record<number, "svt"|"tv4">} */
const KO_BROADCAST_BY_MATCH_NO = {
  // Round of 32 (M073–M088)
  73: "tv4",
  74: "svt",
  75: "svt",
  76: "tv4",
  77: "tv4",
  78: "tv4",
  79: "tv4",
  80: "svt",
  81: "tv4",
  82: "tv4",
  83: "tv4",
  84: "svt",
  85: "tv4",
  86: "svt",
  87: "svt",
  88: "tv4",
  // Round of 16 (M089–M096)
  89: "svt",
  90: "tv4",
  91: "tv4",
  92: "svt",
  93: "tv4",
  94: "tv4",
  95: "tv4",
  96: "svt",
  // Quarter-finals (M097–M100)
  97: "tv4",
  98: "svt",
  99: "tv4",
  100: "svt",
  // Semi-finals (M101–M102)
  101: "svt",
  102: "tv4",
  // Bronze & final (M103–M104)
  103: "svt",
  104: "tv4",
};

/**
 * @param {string} stage
 * @param {string|null|undefined} homeCode
 * @param {string|null|undefined} awayCode
 * @param {number|string|null|undefined} matchNo FIFA match number (73–104) for knockout slots
 * @returns {"svt"|"tv4"|"both"|null}
 */
export function wc2026BroadcasterSweden(stage, homeCode, awayCode, matchNo) {
  if (stage && stage !== "GROUP") {
    const n = matchNo != null && matchNo !== "" ? Number(matchNo) : NaN;
    if (Number.isFinite(n) && KO_BROADCAST_BY_MATCH_NO[n]) {
      return KO_BROADCAST_BY_MATCH_NO[n];
    }
    return null;
  }
  if (!homeCode || !awayCode) return null;
  const h = String(homeCode).toUpperCase();
  const a = String(awayCode).toUpperCase();
  const k1 = `${h}-${a}`;
  const k2 = `${a}-${h}`;
  return GROUP_PAIR[k1] || GROUP_PAIR[k2] || null;
}
